import toggleTheme from './toggleTheme'
import toggleHeaderBG from './toggleHeaderBG'
import closeMenu from './closeMenu'
import toggleLanguage from './toggleLanguage'

const headerHeight = document.querySelector('.header').clientHeight + 10
document.documentElement.style.setProperty(
  '--scroll-padding',
  `${headerHeight - 1}px`
)
// console.log(headerHeight)

document.addEventListener('click', e => {
  // console.log(e.target)
  // console.log(e.target.className)
  if (
    e.target.matches('div[data-toggle-theme]') ||
    e.target.matches('div[data-toggle-theme] *')
  ) {
    // console.log('change icon and theme')

    const theme = e.target.closest('div[data-toggle-theme]').dataset
      .currentTheme

    // console.log(theme)
    toggleTheme(theme)
  }
  if (e.target.matches('div[data-toggle-language]')) {
    // console.log('toggle language')

    const currentLanguage = e.target.textContent
    toggleLanguage(currentLanguage)
  }

  // console.log(e.target.nodeName)
  if (e.target.nodeName !== "svg" && e.target.nodeName !== "path") {
    if (e.target.className.includes('hamburger')) {

      // console.log('show menu!!!!')
      if (window.innerWidth < 768) {
        document
          .querySelector('.hamburger--squeeze')
          .classList.toggle('is-active')
        document.querySelector('.header').classList.toggle('slide-in')
      }
    }
  }

  if (e.target.matches('.header__list li a')) {
    // console.log('close menu!')
    closeMenu()
  }
})

document.addEventListener('scroll', e => {
  // console.log(e)
  // console.log(document.documentElement.offsetTop)
  // console.log(window.scrollY)

  toggleHeaderBG(window.scrollY)
})
